export const DEFAULT_SCREEN_PRINTING_COLOR_ID = 57;

export const screenPrintingColors = {
  // Noir
  [DEFAULT_SCREEN_PRINTING_COLOR_ID]: { value: '#000' },
  // Jaune citron
  58: { value: '#f7ff3c' },
  // Jaune or
  59: { value: '#EFD807' },
  // Orange
  60: { value: '#FF7F00' },
  // Process blue
  61: { value: '#0085ca' },
  // Blanc
  62: { value: '#fff' },
  // Bleu
  63: { value: '#0080FF' },
  // Bleu clair
  64: { value: '#57B5E0' },
  // Bleu foncé
  65: { value: '#00249C' },
  // Reflex bleu
  66: { value: '#171796' },
  // Violet
  67: { value: '#AA0096' },
  // Vert foncé
  68: { value: '#314F40' },
  // Vert clair
  69: { value: '#33A532' },
  // Gris
  70: { value: '#666666' },
  // Marron
  71: { value: '#3D2612' },
  // Gris clair
  72: { value: '#E2E2E2' },
  // Rose
  73: { value: '#C74375' },
  // Bordeaux
  74: { value: '#7D212B' },
  // Warm red
  75: { value: '#F54029' },
  // Rouge
  76: { value: '#EF3340' },
};

export default screenPrintingColors;
